import React from 'react'
import { HomeNav } from '../commons/HomeNav'

export const HomeHeader = () => {
  return (
      <header className='h-full w-full block relative grid-flow-row'>    
          <HomeNav/>
      </header>
  )
}
